"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = void 0;

var storage_1 = __importDefault(require("./storage"));

var uuid_1 = require("../support/uuid");

var unit_1 = require("../unit"); // This can be done with https://github.com/localForage/localForage-getItems if needed


exports.load = function () {
  var unitPromise = new Promise(function (resolve, reject) {
    var units = [];
    storage_1.default.iterate(function (value, key) {
      try {
        var uuid = new uuid_1.UUID(key); // checking if parsable

        units.push(unit_1.decodeUnit(value));
      } catch (RangeError) {
        console.log("Found key not parsable as uuid: " + key);
      }
    }).then(function () {
      resolve(units);
    });
  });
  return unitPromise;
};